var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "400pt",
    viewBox: "-57 0 400 400",
    width: "400pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m111.71875 135.660156c-18.652344-18.0625-29.183594-42.921875-29.183594-68.886718v-56.773438h-40v56.773438c0 25.964843 10.53125 50.824218 29.183594 68.886718l71.382812 69.140625 20-19.371093zm0 0",
    fill: "#d4e1f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m114.132812 269.507812 49.230469-46.191406-20.261719-18.515625-68.96875 64.714844c-19.320312 18.125-30.28125 43.441406-30.28125 69.933594v50.550781h40v-50.554688c0-26.496093 10.960938-51.808593 30.28125-69.9375zm0 0",
    fill: "#d4e1f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m220.589844 262.023438-62.867188-57.4375 63.949219-61.742188c20.597656-19.964844 32.289063-47.382812 32.429687-76.070312v-56.773438c0-5.523438-4.480468-10-10-10-5.523437 0-10 4.476562-10 10v56.773438c-.136718 23.273437-9.636718 45.515624-26.359374 61.707031l-64.53125 62.394531-64.703126-62.394531c-16.738281-16.183594-26.253906-38.425781-26.40625-61.707031v-56.773438c0-5.523438-4.480468-10-10-10-5.523437 0-10 4.476562-10 10v56.773438c.144532 28.6875 11.839844 56.109374 32.441407 76.070312l63.957031 61.835938-61.140625 57.539062c-21.246094 20.0625-33.28125 48-33.257813 77.226562v50.554688c0 5.523438 4.476563 10 10 10 5.519532 0 10-4.476562 10-10v-50.554688c-.011718-23.710937 9.757813-46.371093 27-62.644531l62.152344-58.378906 63.875 58.359375c17.789063 16.289062 27.9375 39.289062 27.972656 63.40625v49.8125c0 5.523438 4.476563 10 10 10 5.519532 0 10-4.476562 10-10v-49.8125c-.054687-29.738281-12.574218-58.089844-34.511718-78.164062zm0 0",
    fill: "#2f55d4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2eca8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m276.199219 20h-266.199219c-5.523438 0-10-4.476562-10-10s4.476562-10 10-10h266.199219c5.523437 0 10 4.476562 10 10s-4.476563 10-10 10zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.199219 400h-266.199219c-5.523438 0-10-4.476562-10-10s4.476562-10 10-10h266.199219c5.523437 0 10 4.476562 10 10s-4.476563 10-10 10zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sand-clock.4e026b5f6b789a5a71e6dd7f3498943d.svg";
export { ForwardRef as ReactComponent };